<template>
    <div>
        <van-nav-bar v-if="!isMonitoring" left-arrow left-text="" title="房抵项目详情" @click-left="back"
            @click-right="menuActive" fixed :z-index="zIndex">
            <van-icon name="weapp-nav" slot="right" />
        </van-nav-bar>

        <van-nav-bar v-else left-arrow left-text="" title="房抵项目详情" @click-left="back" fixed :z-index="zIndex" />

        <van-tabs v-model="active" sticky :lazy-render="false" type="line" :offset-top="46" v-if="applyId">

            <van-tab title="申请详情" style="margin-top: 46px;" :name="1">
                <ApplyInfo :applyId="applyId" />
            </van-tab>

            <van-tab title="申请资料" style="margin-top: 46px" v-if="parseInt(auditStatus) > 0" :name="2">
                <ApplyData ref="applyDataModule" :applyId="applyId" />
            </van-tab>

            <van-tab title="下户面谈" style="margin-top: 46px"
                v-if="parseInt(applyInfo.trustLastAudit) != 2 && parseInt(auditStatus) > 1" :name="4">
                <WarrantInterview ref="interviewModule" :applyId="applyId" />
            </van-tab>

            <van-tab title="初审意见" style="margin-top: 46px"
                v-if="parseInt(applyInfo.trustLastAudit) != 2 && parseInt(auditStatus) == 3" :name="5">
                 <RiskFirstTrial ref="riskFinalModule" :applyId="applyId" />
            </van-tab>

            <van-tab title="初审意见" style="margin-top: 46px"
                v-if="parseInt(applyInfo.trustLastAudit) != 2 && parseInt(auditStatus) > 3" :name="6">
                 <RiskFirstTrialView ref="riskFinalViewModule" :applyInfo="applyInfo" />
            </van-tab>

            <van-tab title="合同签订" style="margin-top: 55px;" v-if="parseInt(auditStatus) > 6" :name="7">
                <ContractGather ref="contractModule" :applyId="applyId" />
            </van-tab>

<!--            <van-tab title="担保措施" style="margin-top: 46px" v-if="parseInt(auditStatus) > 6" :name="9">-->
<!--                <Guarantee ref="warrentModule" :applyId="applyId" />-->
<!--            </van-tab>-->

<!--            <van-tab title="征信" style="margin-top: 46px" v-if="parseInt(applyInfo.trustLastAudit) != 2 && parseInt(auditStatus) > 2" :name="10">-->
<!--                <span>请登录PC端查看</span>-->
<!--                &lt;!&ndash; <p style="padding: 10px;color: red;font-weight: bold">征信以截图的方式展示，前提是信贷网页版有生成征信截图</p> &ndash;&gt;-->
<!--                &lt;!&ndash; <oss-upload :applyId="applyId" :groupCode="1001" refName="zxjt" /> &ndash;&gt;-->
<!--            </van-tab>-->

            <van-tab title="审批记录" style="margin-top: 55px;" v-if="parseInt(auditStatus) > 0" :name="11">
                <ApprovalRecords ref="recordsModule" :applyId="applyId" />
            </van-tab>

        </van-tabs>

        <!-- 通用审批-->
        <van-action-sheet v-model="menus" :actions="actions" close-on-click-action @select="selectAudit" />

        <van-dialog v-model="auditShow" :title="auditTitle" show-cancel-button :before-close="auditConfirm"
            @cancel="auditShow = false">
            <van-field type="textarea" size="large" v-model="remark" :error-message="remarkErr" placeholder="请输入审批意见" />
        </van-dialog>

        <!--风控复审审批通过-->
        <van-dialog v-if="auditStatus == '4'" v-model="riskFinalJudgmentShow" :title="auditTitle" show-cancel-button
            :before-close="auditConfirm" @cancel="riskFinalJudgmentShow = false">
            <van-field type="text" label="业务类型" v-model="riskFinalJudgmentData.productName" readonly />
            <van-field type="text" label="审批金额(元)" v-model="riskFinalJudgmentData.approveAmt" readonly />
            <van-field type="text" label="审批期限" v-model="riskFinalJudgmentData.approveNo" readonly />
            <van-field type="text" v-if="applyInfo.productFlag !== '1100110'" label="匹配产品利率(%)"
                v-model="riskFinalJudgmentData.approveRate" readonly />
            <van-field type="text" v-if="applyInfo.productFlag !== '1100110'" label="销售结算利率(%)"
                v-model="riskFinalJudgmentData.nominalRate" readonly />
            <van-field type="text" v-if="applyInfo.productFlag !== '1100110' && applyInfo.floatRate > 0" label="上浮利率(%)"
                v-model="riskFinalJudgmentData.floatRate" readonly />
            <van-field type="text" v-if="applyInfo.productFlag === '1100110'" label="借款日利率" v-model="riskFinalJudgmentData.dayRate"
                readonly />
            <van-field type="text" label="出款机构" v-model="riskFinalJudgmentData.sourceCompanyName" readonly />
            <van-field type="text" label="出款机构资金包" v-model="riskFinalJudgmentData.productCapitalName" readonly />
            <van-field type="text" label="出款机构匹配产品" v-model="riskFinalJudgmentData.supplierProductName" readonly />
            <van-field type="textarea" size="large" v-model="remark" :error-message="remarkErr" placeholder="请输入审批意见" />
        </van-dialog>


        <!--风控复审驳回-->
        <van-dialog v-if="auditStatus == '4'" v-model="processRejectShow" :title="auditTitle" show-cancel-button
            :before-close="auditConfirm" @cancel="processRejectShow = false">
            <van-field type="text" label="驳回至" placeholder="点击选择驳回环节" v-model="jumpToCn" readonly
                @click="processRejectSelectShow = true" />

            <van-field type="textarea" size="large" v-model="processRejectRemark" :error-message="remarkErr"
                placeholder="请输入审批意见" />
        </van-dialog>

        <!-- 风控复审驳回选项 -->
        <van-popup position="bottom" v-model="processRejectSelectShow" :overlay="true">
            <van-picker title="请选择驳回环节" show-toolbar :columns="processRejectColumns" @confirm="onProcessRejectConfirm"
                @change="changeRejectSelect" @cancel="processRejectSelectShow = false" />
        </van-popup>
        <!-- 总经理审批 -->
        <van-dialog
                v-if="auditStatus == '12'"
                v-model="auditCeoShow"
                :title="auditTitle"
                show-cancel-button
                :before-close="auditConfirm"
                @cancel="auditCeoShow=false"
        >
            <van-field type="text" label="审批金额" v-model="ceo.approveAmt" readonly/>
            <van-field type="text" label="审批期限" v-model="ceo.approveNo" readonly/>
            <van-field type="text" v-if="applyInfo.productFlag !== '1100110' " label="借款年利率"
                       v-model="ceo.approveRate" readonly/>
<!--            <van-field type="text" v-if="applyInfo.productFlag !== '1100110' " label="销售结算利率"-->
<!--                       v-model="ceo.nominalRate" readonly/>-->
            <van-field type="text" v-if="applyInfo.productFlag !== '1100110'&&applyInfo.floatRate>0 " label="上浮利率%"
                       v-model="ceo.floatRate" readonly/>
            <van-field type="text" v-if="applyInfo.productFlag === '1100110' " label="借款日利率" v-model="ceo.dayRate"
                       readonly/>
            <van-field type="textarea" size="large" v-model="remark" :error-message="remarkErr" placeholder="请输入审批意见"/>
        </van-dialog>

        <!-- 资方审批 -->
        <van-dialog v-if="auditStatus == '6'" v-model="auditTrustShow" :title="auditTitle" show-cancel-button
            :before-close="auditConfirm" @cancel="auditTrustShow = false">
            <van-field v-if="auditType == 'pass'" type="text" label="审批金额" v-model="trust.approveAmt" />
            <van-field v-if="auditType == 'pass'" type="text" label="审批期限" v-model="trust.approveNo" />
            <van-field type="textarea" size="large" v-model="remark" :error-message="remarkErr" placeholder="请输入审批意见" />
        </van-dialog>
        <!--驳回审批 -->
        <!-- <RejectedLoanDialog v-if="auditStatus == 8" :applyId="applyId"></RejectedLoanDialog> -->
        <!--申请信托审核 -->
        <TrustLoanApprovalDialog v-if="auditStatus == 8" :applyId="applyId"></TrustLoanApprovalDialog>
        <!-- 提款申请/出纳放款审批-->
        <LoanAuditDialog v-if="auditStatus == 10 || auditStatus == 11" :applyId="applyId"></LoanAuditDialog>
        <!--专员审批-->
        <HeadAuditDialog v-if="auditStatus == 1" :applyId="applyId"></HeadAuditDialog>
    </div>
</template>

<script type="text/ecmascript-6">
import { auditProcess, hangApplyProcess, rejectProcess } from '@/api/loanInfo'
import { eventBus } from '@/vue/utils/eventBus'
import { mapGetters } from 'vuex'
import FilesUpload from '@/views/home/business/mortgage/files-upload.vue'
import ossUpload from '@/views/component/oss-upload'
//特殊审批类窗口
import RejectedLoanDialog from './dialog/rejected-loan'
// 出纳放款
import LoanAuditDialog from './dialog/loan-audit'
// 申请信托审核
import TrustLoanApprovalDialog from './dialog/trust-loan-approval-dialog.vue'
// 橙易贷专员初审
import HeadAuditDialog from './dialog/assistant-first-trial-dialog.vue'
// 申请资料
import ApplyData from '@/views/home/business/mortgage/module/apply-data.vue'
// 申请详情
import ApplyInfo from '@/views/home/business/mortgage/module/apply-info.vue'
// 下户面谈
import WarrantInterview from '@/views/home/business/mortgage/module/warrant-interview.vue'
// 风控初审意见
import RiskFirstTrial from '@/views/home/business/mortgage/module/risk-first-trial.vue'
// 风控初审意见（视图）
import RiskFirstTrialView from '@/views/home/business/mortgage/module/risk-first-trial-view.vue'
// 合同抵押公证
import ContractGather from '@/views/home/business/mortgage/module/contract-gather.vue'
// 担保措施
import Guarantee from '@/views/home/business/mortgage/module/guarantee.vue'
// 审批记录
import ApprovalRecords from '@/views/home/business/mortgage/module/approval-records.vue'

export default {
    name: 'mortgage_info',
    props: {},
    computed: mapGetters([
        'auditStatus',
        'applyInfo',
        'isMonitoring'
    ]),
    components: {
        // 申请详情
        ApplyInfo,
        // 申请资料
        ApplyData,
        // 下户面谈
        WarrantInterview,
        // 风控初审
        RiskFirstTrial,
        // 审批记录
        ApprovalRecords,
        // 风控初审视图
        RiskFirstTrialView,
        // 担保措施
        Guarantee,
        // 合同
        ContractGather,
        // 申请信托提款
        TrustLoanApprovalDialog,
        FilesUpload,
        RejectedLoanDialog,
        LoanAuditDialog,
        HeadAuditDialog,
        ossUpload,
    },
    watch: {
        remark(val) {
            if (val.length > 0) {
                this.remarkErr = ''
            }
        },
        realName(val) {
            if (val.length > 0) {
                this.realNameErr = ''
            }
        }
    },
    data: function () {
        return {
            applyId: '',
            menus: false,
            auditShow: false,
            riskFinalJudgmentShow: false,
            auditOperation: '',//1 是通用审批，2是拒单 3 客户放弃 4 风控复审指定驳回 5 资方审批
            auditProcess: '',//当天流程节点，传给后台
            nextStep: '',
            auditType: '',//传给后台的type
            auditTitle: '',
            active: '0',
            outCome: '',//审批状态：通过、驳回、拒单等
            zIndex: 999,
            remark: '',
            remarkErr: '',
            actions: [
                { name: '通过', status: '1' },
                { name: '驳回', status: '3' },
                { name: '拒单', status: '5' }
            ],
            //风控复审·
            riskFinalJudgmentData: {
                approveAmt: '',
                approveNo: '',
                dayRate: '',
                approveRate: '',
                nominalRate: '',
                floatRate: '',
                productName: '',
                sourceCompanyName: '',
                supplierProductName: '',
                productCapitalName: '',
            },
            auditCeoShow: false,
            ceo: {
                approveAmt: '',
                approveNo: '',
                approveRate: '',
                floatRate:'',
                dayRate: '',
                nominalRate:''
            },
            auditTrustShow: false,
            trust: {
                approveAmt: '',
                approveNo: ''
            },
            processRejectColumns: ['橙易贷专员', '风控初审'],
            processRejectShow: false,//风控复审流程驳回窗口
            processRejectSelectShow: false,
            jumpTo: '',
            jumpToCn: '',
            processRejectRemark: ''
        }
    },
    filters: {},
    methods: {
        // 有些节点初始化的时候跳过去
        initActive() {
            let self = this
            setTimeout(function () {
                switch (self.auditStatus) {
                    case '2': // 下户面谈
                        self.active = 4
                        break
                    case '3': // 风控初审
                        self.active = 5
                        break
                    case '4': // 风控复审
                        self.active = 6
                        break
                    case '7': //合同/抵押/公证
                        self.active = 7
                        break
                    case '10': // 申请信托审核
                        self.active = 9
                        break
                }
            }, 1000)
        },
        menuActive() {
            this.menus = true
        },
        selectAudit(item, index) {
            this.outCome = item.status
            //FIXME 分发不同审批功能
            console.log('audit')
            switch (this.auditStatus) {
                case '1':
                    // 橙易贷专员初审
                    this.handleAssistantFirstTrialAudit(item)
                    break;
                case '2':
                    // 下户面谈
                    this.handleWarrantInterviewAudit(item)
                    break;
                case '3':
                    //风控初审
                    this.handleRiskFirstTrialAudit(item)
                    break;
                case '4':
                    // 风控复审
                    this.handleRiskFinalJudgmentAudit(item)
                    break;
                case '5':
                    // 贷审会审批
                    this.handleLoanReviewCommitteeAudit(item)
                    break;

                case '12':
                    // 总经理审核
                    this.ceoAudit(item)
                    break;
                case '6':
                    // 资方审批
                    this.handleTrustAudit(item)
                    break;
                case '7':
                    // 合同/抵押/公证
                    this.handleContractAudit(item)
                    break;
                case '8':
                    // 申请信托审核
                    this.handleTrustLoanApprovalAudit(item)
                    break;
                case '9':
                    // 担保方审批
                    break;
                case '10':
                    // 提款申请
                    this.handleApplyForWithdrawalAudit(item)
                    break;
                case '11':
                    // 出纳提款申请
                    this.handleCashierLoanAudit(item)
                    break;
            }
        },
        back() {
            this.$router.go(-1)
        },
        toTab(index) {
            this.active = index
            this.menuShow = false

        },
        // 橙易贷专员初审
        handleAssistantFirstTrialAudit(item) {
            //通过1 驳回2 拒单3 客户放弃4
            this.auditShow = true
            this.auditProcess = 'ASSISTANT_FIRST_TRIAL'
            if (item.status == '1') {
                this.auditShow = false
                eventBus.$emit('assistant-first-trial-dialog', item)
            } else if (item.status == '2') {
                this.auditTitle = '驳回'
                this.auditType = 'reject'
                this.auditOperation = '1'
            } else if (item.status == '3') {
                this.auditTitle = '拒单'
                this.auditType = 'denied'
                this.auditOperation = '2'
            } else if (item.status == '4') {
                this.auditTitle = '客户放弃'
                this.auditType = 'abandoned'
                this.auditOperation = '2'
            }
        },
        // 下户面谈
        handleWarrantInterviewAudit(item) {
            //子组件处理
            eventBus.$emit('warrant-interview-audit', item.status)
        },
        // 风控初审
        handleRiskFirstTrialAudit(item) {
            //保存初审意见和审批通过子模块自己处理
            if (item.status == '1' || item.status == '7') {
                this.active = 5
                eventBus.$emit('risk-first-trial-audit', item)
            } else {
                this.auditProcess = 'RISK_FIRST_TRIAL'
                this.auditShow = true
                //驳回和拒单走通用审批
                if (item.status == '2') {
                    this.auditTitle = '驳回'
                    this.auditType = 'reject'
                    this.auditOperation = '1'
                } else if (item.status == '3') {
                    this.auditTitle = '拒单'
                    this.auditType = 'denied'
                    this.auditOperation = '2'
                } else if (item.status == '5') {
                    this.auditTitle = '挂单'
                    this.auditOperation = '3'
                }
            }
        },
        // 风控复审
        handleRiskFinalJudgmentAudit(item) {
            //初始化审批信息
            this.riskFinalJudgmentData.approveAmt = this.applyInfo.approveAmt
            this.riskFinalJudgmentData.approveNo = this.applyInfo.approveNo
            this.riskFinalJudgmentData.dayRate = this.applyInfo.dayRate
            this.riskFinalJudgmentData.approveRate = this.applyInfo.approveRate
            this.riskFinalJudgmentData.nominalRate = this.applyInfo.nominalRate
            this.riskFinalJudgmentData.floatRate = this.applyInfo.floatRate
            this.riskFinalJudgmentData.productName = this.applyInfo.productName
            this.riskFinalJudgmentData.sourceCompanyName = this.applyInfo.sourceCompanyName
            this.riskFinalJudgmentData.supplierProductName = this.applyInfo.supplierProductName
            this.riskFinalJudgmentData.productCapitalName = this.applyInfo.productCapitalName

            if (item.status === '1') {
                this.auditTitle = '通过'
                this.riskFinalJudgmentShow = true
                this.auditOperation = '1'
                this.auditProcess = 'RISK_FINAL_JUDGMENT'
                this.auditType = 'pass'
            } else if (item.status === '3') {
                this.auditTitle = '流程驳回'
                this.processRejectShow = true
            }
        },
        //风控复审流程驳回
        onProcessRejectConfirm(val, index) {
            this.jumpToCn = this.processRejectColumns[index]
            this.auditOperation = 4
            if (index == 0) {
                // 驳回专员初审
                this.jumpTo = 'ASSISTANT_FIRST_TRIAL'
            } else if (index == 1) {
                // 驳回风控初审
                this.jumpTo = 'RISK_FIRST_TRIAL'
            }

            this.processRejectSelectShow = false
        },
        //风控复审选择驳回环节触发，解决延迟问题
        changeRejectSelect(picker, values, index) {
            this.jumpToCn = this.processRejectColumns[index]
            if (index == 0) {
                this.jumpTo = 'ASSISTANT_FIRST_TRIAL'
            } else if (index == 1) {
                this.jumpTo = 'RISK_FIRST_TRIAL'
            }
        },
        // 贷审会
        handleLoanReviewCommitteeAudit(item) {
            this.auditShow = true
            this.auditProcess = 'LOAN_REVIEW_COMMITTEE'
            if (item.status === '1') {
                this.auditTitle = '通过'
                this.auditOperation = '1'
                this.auditType = 'pass'
            } else if (item.status === '2') {
                this.auditTitle = '驳回'
                this.auditOperation = '1'
                this.auditType = 'reject'
            }
        },
        //总经理审批
        ceoAudit(item) {
            //初始化审批信息
            this.ceo.approveAmt = this.applyInfo.approveAmt
            this.ceo.approveNo = this.applyInfo.approveNo
            this.ceo.dayRate = this.applyInfo.dayRate
            this.ceo.approveRate = this.applyInfo.approveRate
            this.ceo.nominalRate = this.applyInfo.nominalRate
            this.ceo.floatRate = this.applyInfo.floatRate

            this.auditCeoShow = true

            if (item.status === '1') {
                this.auditTitle = '通过'
                this.auditOperation = '1'
                this.auditProcess = 'CEO'
                this.auditType = 'pass'
            } else if (item.status === '2') {
                this.auditTitle = '驳回'
                this.auditOperation = '1'
                this.auditProcess = 'CEO'
                this.auditType = 'reject'
            }
        },
        // 资方审批
        handleTrustAudit(item) {
            //初始化审批信息
            this.trust.approveAmt = this.applyInfo.approveAmt
            this.trust.approveNo = this.applyInfo.approveNo

            this.auditTrustShow = true

            if (item.status === '1') {
                this.auditTitle = '通过'
                this.auditOperation = '5'
                this.auditProcess = 'TRUST_LAST_LOAN'
                this.auditType = 'pass'
            } else if (item.status === '2') {
                this.auditTitle = '驳回'
                this.auditOperation = '1'
                this.auditProcess = 'TRUST_LAST_LOAN'
                this.auditType = 'reject'
            }
            console.log(this.auditType)
        },
        // 合同抵押公证
        handleContractAudit(item) {
            if (item.status === '1' || item.status === '2' || item.status === '3') {
                //子组件处理
                eventBus.$emit('contractGatherAudit', item.status)
            } else {
                //挂单、拒单、客户放弃走通用审批
                this.auditProcess = 'CONTRACT_GATHER'
                if (item.status === '4') {
                    this.auditTitle = '挂单'
                    this.auditOperation = '3'
                    this.auditShow = true
                } else if (item.status === '5') {
                    this.auditTitle = '拒单'
                    this.auditType = 'denied'
                    this.auditOperation = '2'
                    this.auditShow = true
                } else if (item.status === '6') {
                    this.auditTitle = '客户放弃'
                    this.auditType = 'abandoned'
                    this.auditOperation = '2'
                    this.auditShow = true
                } else if (item.status === '7') {  //保存担保措施
                    eventBus.$emit('mortgageAudit', 1)
                }
            }
        },
        // 申请信托审核
        handleTrustLoanApprovalAudit(item) {
            this.auditProcess = 'TRUST_LOAN_APPROVAL'
            console.log(item)
            if (item.status == '1') {
                // this.auditTitle = '通过'
                // this.auditOperation = '1'
                // this.auditType = 'pass'
                // this.auditShow = true
                eventBus.$emit('trustLoanApprovalAudit')
            } else {
                if (item.status === '2') {
                    this.auditShow = true
                    this.auditTitle = '拒单'
                    this.auditType = 'denied'
                    this.auditOperation = '2'
                } else if (item.status === '3') {
                    this.auditShow = true
                    this.auditTitle = '客户放弃'
                    this.auditType = 'abandoned'
                    this.auditOperation = '2'
                }
            }
        },
        // 提款申请
        handleApplyForWithdrawalAudit(item) {
            //审核通过
            if (item.status === '1') {
                eventBus.$emit('loan-audit-dialog', { type: 'pass', process: 'APPLY_FOR_WITHDRAWAL', title: '提款申请' })
            } else {
                //驳回走通用
                this.auditProcess = 'APPLY_FOR_WITHDRAWAL'
                this.auditShow = true
                this.auditTitle = '驳回'
                this.auditType = 'reject'
                this.auditOperation = '1'
            }
        },
        // 出纳放款
        handleCashierLoanAudit(item) {
            //审核通过
            if (item.status === '1') {
                eventBus.$emit('loan-audit-dialog', { type: 'pass', process: 'CASHIER_LOAN', title: '财务出纳放款' })
            } else {
                //驳回走通用
                this.auditProcess = 'CASHIER_LOAN'
                this.auditShow = true
                this.auditTitle = '驳回'
                this.auditType = 'reject'
                this.auditOperation = '1'
            }
        },
        //普通审批(通过、驳回、拒单、客户放弃)
        auditConfirm(action, done) {
            if (action === 'confirm') {

                if (this.auditOperation == 1) {  //通用审批

                    if (this.remark == '') {
                        this.remarkErr = '审批意见不能为空'
                        done(false)
                        return false
                    }
                    done()

                    let params = {
                        applyId: this.applyId,
                        remark: this.remark,
                        process: this.auditProcess,
                        type: this.auditType,
                        nextStep: this.nextStep
                    }
                    auditProcess(params).then(res => {
                        if (res.success) {
                            this.$toast(res.msg)
                            this.$router.go(-1)
                        } else {
                            this.$toast(res.msg)
                        }
                    })
                } else if (this.auditOperation == 2) {

                    if (this.remark == '') {
                        this.remarkErr = '审批意见不能为空'
                        done(false)
                        return false
                    }
                    done()
                    //拒单和放弃
                    let params = {
                        applyId: this.applyId,
                        remark: this.remark,
                        process: this.auditProcess,
                        type: this.auditType
                    }
                    auditProcess(params).then(res => {
                        this.$toast(res.msg)
                        if (res.success) {
                            this.$router.go(-1)
                        }
                    })
                } else if (this.auditOperation == 3) {
                    if (this.remark == '') {
                        this.remarkErr = '审批意见不能为空'
                        done(false)
                        return false
                    }
                    done()
                    //挂单
                    let params = {
                        applyId: this.applyId,
                        remark: this.remark,
                        process: this.auditProcess,
                    }
                    hangApplyProcess(params).then(res => {
                        this.$toast(res.msg)
                        if (res.success) {
                            this.$router.go(-1)
                        }
                    })
                } else if (this.auditOperation == 4) {

                    if (this.processRejectRemark == '') {
                        this.processRejectRemarkErr = '审批意见不能为空'
                        done(false)
                        return false
                    }
                    done()

                    //风控复审指定驳回
                    let params = {
                        applyId: this.applyId,
                        jumpTo: this.jumpTo,
                        remark: this.processRejectRemark
                    }

                    rejectProcess(params).then(res => {
                        this.$toast(res.msg)
                        if (res.success) {
                            this.$router.go(-1)
                        }
                    })
                } else if (this.auditOperation == 5) {

                    if (this.remark == '') {
                        this.remarkErr = '审批意见不能为空'
                        done(false)
                        return false
                    }
                    done()

                    //资方审批
                    let params = {
                        applyId: this.applyId,
                        process: this.auditProcess,
                        remark: this.remark,
                        type: this.auditType,
                        approveAmt: this.trust.approveAmt,
                        approveNo: this.trust.approveNo,
                    }

                    auditProcess(params).then(res => {
                        this.$toast(res.msg)
                        if (res.success) {
                            this.$router.go(-1)
                        }
                    })
                }
            } else {
                this.remarkErr = ''
                done()
            }
        },
        switchTab(index) {
            let self = this
            setTimeout(() => {
                self.active = index
            }, 500)
        },
        initMenus() {
            let self = this
            // 初始化当前节点的审批菜单
            if (self.auditStatus == '1') {//专员初审
                self.actions = [
                    { name: '审核通过', status: '1' },
                    { name: '驳回', status: '2' },
                    { name: '拒单', status: '3' },
                    { name: '客户放弃', status: '4' }
                ]
            } else if (self.auditStatus == '2') {//下户面谈
                self.actions = [
                    { name: '下户面谈完成', status: '1' },
                    { name: '驳回', status: '2' },
                    { name: '客户放弃', status: '3' },
                    { name: '拒单', status: '4' }
                ]
            } else if (self.auditStatus == '3') {//风控初审
                self.actions = [
                    { name: '保存初审意见', status: '7' },
                    { name: '审核通过', status: '1' },
                    { name: '驳回', status: '2' },
                    { name: '拒单', status: '3' },
                    { name: '客户放弃', status: '4' },
                    { name: '挂单', status: '5' }
                ]
            } else if (self.auditStatus == '4') {//风控复审
                self.actions = [
                    { name: '通过', status: '1' },
                    { name: '流程驳回', status: '3' }
                ]
            } else if (self.auditStatus == '5') {//贷审会审批
                self.actions = [
                    { name: '审核通过', status: '1' },
                    { name: '驳回', status: '2' }
                ]
            } else if (self.auditStatus == '6') {//资方审批
                self.actions = [
                    { name: '审核通过', status: '1' },
                    { name: '驳回', status: '2' },
                    { name: '拒单', status: '5' },
                    { name: '客户放弃', status: '6' }
                ]
            } else if (self.auditStatus == '7') {//合同签订
                self.actions = [
                    { name: '修改到期日期', status: '1' },
                    { name: '生成还款计划', status: '2' },
                    { name: '保存担保措施', status: '7' },
                    { name: '审核通过', status: '3' },
                    { name: '挂单', status: '4' },
                    { name: '拒单', status: '5' },
                    { name: '客户放弃', status: '6' }
                ]
            } else if (self.auditStatus == '8') {//申请信托审核
                self.actions = [
                    { name: '审核通过', status: '1' },
                    { name: '拒单', status: '2' },
                    { name: '客户放弃', status: '3' }
                ]
            } else if (self.auditStatus == '10') {//提款申请
                self.actions = [
                    { name: '审核通过', status: '1' },
                    { name: '驳回', status: '2' },
                ]
            } else if (self.auditStatus == '11') {//出纳放款
                self.actions = [
                    { name: '放款', status: '1' },
                    { name: '驳回', status: '2' },
                ]
            } else if (self.auditStatus == '12') {// 总经理审核
                self.actions = [
                  { name: '审核通过', status: '1' },
                  { name: '驳回', status: '2' },
                ]
            }
            //初始化节点对应页面
            self.initActive()
        }
    },
    mounted() {
        //初始化action(每个流程节点不同的审批功能)
        let self = this
        this.applyId = this.$route.params.id
        //初始化不同环节的审批菜单
        this.initMenus()
        //TODO 目前通知事件auditStatus变动，主要作为刷新
        eventBus.$on('auditStatus', function (auditStatus) {
            self.initMenus()
        })
    },
    destroyed() {

    }
}
</script>

<style scope>
.button-row {
    margin: 20px;
}

.button-row button {
    margin-left: 10px;
    margin-top: 10px;
}

.file_row .van-row {
    margin-top: 5px;
    text-align: center;
}
</style>
